'use client';

import React from 'react';
import styled from 'styled-components';

import FilterRadio from './FilterRadio/FilterRadio';

export interface FilterRadioOption<T extends string> {
  id: T;
  value: T;
  label: string;
}

interface FilterRadioGroupProps<T extends string> {
  selectedValue: T;
  onChange: (value: T) => void;
  options: FilterRadioOption<T>[];
}

const FilterRadioGroup = <T extends string>({ selectedValue, onChange, options }: FilterRadioGroupProps<T>) => {
  return (
    <Container role="radiogroup" aria-label="진행 상태 필터">
      {options.map((option) => (
        <FilterRadio
          key={option.id}
          id={option.id}
          name="filter"
          value={option.value}
          label={option.label}
          checked={selectedValue === option.value}
          onChange={() => onChange(option.value)}
        />
      ))}
    </Container>
  );
};

export default FilterRadioGroup;

const Container = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;
